"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventDescription = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var EventDescription = function (_a) {
    var canSubmit = _a.canSubmit, charLimit = _a.charLimit, onChange = _a.onChange, onSubmit = _a.onSubmit, value = _a.value;
    var _b = react_1.useState(0), chars = _b[0], setChars = _b[1];
    return (react_1.default.createElement("div", { className: 'storybook-producer-description' },
        react_1.default.createElement("textarea", { className: 'storybook-producer-description-textarea', disabled: !canSubmit, maxLength: charLimit, placeholder: 'Toelichting (optioneel)', rows: 1, style: { resize: 'none' }, onChange: function (e) {
                if (e.target.value.length <= charLimit) {
                    setChars(e.target.value.length);
                    onChange(e.target.value);
                }
            }, value: value }),
        react_1.default.createElement("span", { className: 'storybook-producer-description-charcount' },
            chars,
            "/",
            charLimit),
        react_1.default.createElement(storybook_1.Buttons.Button, { className: storybook_1.Helpers.arrayToString(__spreadArray([
                'storybook-producer-submit-event'
            ], (!canSubmit ? ['storybook-producer-submit-event-disabled'] : []))), onClick: function () { return canSubmit ? onSubmit() : function () { }; }, type: 'secondary' }, "Opslaan")));
};
exports.EventDescription = EventDescription;
exports.EventDescription.propTypes = {
    canSubmit: prop_types_1.default.bool,
    charLimit: prop_types_1.default.number,
    onSubmit: prop_types_1.default.func,
    value: prop_types_1.default.string,
};
exports.EventDescription.defaultProps = {
    canSubmit: false,
    charLimit: 200,
    onSubmit: function () { },
    value: '',
};
